import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import NavigationItem from '../Navigation/NavigationItem';

const LogoutWrapper = styled.div`
  display: flex;
  /* align-items: flex-end; */
  align-self: flex-end;
  /* height: 100%; */
  /* margin-top: 50px; */
`;

const NavigationLogoutWrapper = ({ logout }) => {
  return (
    <LogoutWrapper>
      <NavigationItem secondary textcenter bigBtn onClick={logout}>
        Log uit
      </NavigationItem>
    </LogoutWrapper>
  );
};

NavigationLogoutWrapper.propTypes = {
  logout: PropTypes.func
};

export default NavigationLogoutWrapper;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationLogout.js